// extracted by mini-css-extract-plugin
export const link = "link-module--link--25bGM";